module.exports = __webpack_public_path__ + "img/ban7.70b7165b.jpg";